module.exports = __webpack_public_path__ + "static/media/025-lithuania.1d85c675.svg";